<template>
  <CContainer class="d-flex content-center min-vh-100">
    <b-row class="justify-content-center" no-gutters>
      <b-col></b-col>
    </b-row>
  </CContainer>
</template>

<script>
import { mapGetters } from "vuex";
import gql from "graphql-tag";

export default {
  name: "Scheduler",
  data() {
    return {};
  },
  async mounted() {
    await this.loadData();
  },
  methods: {
    async loadData() {
      try {
        let response = await this.$apollo.query({
          query: gql`
          query report_scheduler {
            report_scheduler
          }
        `,
        });
      } catch (error) {
        console.log(error)
      }
    },
  },
};
</script>
